
declare global {
  interface Window {
    $: any;
    jQuery: any;
  }
}
import { Component, Vue } from 'vue-property-decorator';
import 'air-datepicker/dist/css/datepicker.min.css';
import moment from 'moment';
import { VMoney } from 'v-money';

const $ = require('jquery');
window.$ = $;
window.jQuery = $;
require('air-datepicker');

@Component({
  components: {},
  computed: {},
  filters: {},
  watch: {
    'data.assignment_percent_aon.value'() {
      (this as any).clearFieldError('assignment_percent_aon');
    },
    'data.currency_id.value'() {
      (this as any).clearFieldError('currency_id');
    },
  },
  directives: { money: VMoney },
})
export default class NewRequestConditions extends Vue {
  seleccione: string = 'seleccione';
  title: string = 'Crear Solicitud';
  data: any = {
    policy_number: {
      value: '',
      label: 'Número de Póliza',
      error: false,
      errorMessage: ''
    },
    validity_from: {
      value: '',
      label: 'Vigencia Póliza desde',
      error: false,
      errorMessage: ''
    },
    validity_to: {
      value: '',
      label: 'Vigencia Póliza hasta',
      error: false,
      errorMessage: ''
    },
    assignment_percent_aon: {
      value: '',
      label: 'Porcentaje de Cesión a AON',
      error: false,
      errorMessage: ''
    },
    assignmentValidityAonFrom: {
      value: '',
      label: 'Vigencia Cesión AON desde',
      error: false,
      errorMessage: ''
    },
    assignmentValidityAonTo: {
      value: '',
      label: 'Vigencia Cesión AON hasta',
      error: false,
      errorMessage: ''
    },
    currency_id: {
      value: '',
      label: 'Moneda',
      error: false,
      errorMessage: ''
    },
    money: {
      decimal: ',',
      thousands: '.',
      prefix: '',
      suffix: '%',
      precision: 2,
      masked: true,
    },
  };
  currencies: any = [];

  async mounted() {
    if (this.$store.state.newRequest.currentStep < 2) {
      this.$router.push('/requests');
    } else {
      await this.loadCurrencies();
      this.loadFilledData();
    }
    (this as any).$root.localizeDatepicker($);
    this.init();
  }

  async init() {
    const _this = this;
    $('.calendar').each(function(this: any) {
      let elem = $(this).find('input');
      elem.datepicker({
        language: 'es',
        autoClose: true,
        dateFormat: 'yyyy/mm/dd',
        onSelect: function onSelect(formattedDate, selectedDate) {
          let fieldName = elem.attr('model');

          if (!formattedDate) {
            _this.data[fieldName].value = '';
            return;
          }

          let dateString = moment(selectedDate).format('YYYY/MM/DD');
          _this.data[fieldName].value = dateString;
          _this.clearFieldError(fieldName);
          
          if (fieldName === 'validity_from') {
            _this.data.assignmentValidityAonFrom.value = dateString;
            _this.clearFieldError('assignmentValidityAonFrom');
            $('#assignmentValidityAonFrom').val(dateString);
          }
          
          if (fieldName === 'validity_to') {
            _this.data.assignmentValidityAonTo.value = dateString;
            _this.clearFieldError('assignmentValidityAonTo');
            $('#assignmentValidityAonTo').val(dateString);
          }
        },
      });
    });
  }

  clearFieldError(fieldName: string) {
    if (this.data[fieldName] && this.data[fieldName].error) {
      this.data[fieldName].error = false;
      this.data[fieldName].errorMessage = '';
    }
  }

  onDateInput(fieldName: string, event: Event) {
    const inputValue = (event.target as HTMLInputElement).value;
    this.data[fieldName].value = inputValue;
    if (inputValue) {
      this.clearFieldError(fieldName);
    }
  }

  onDateBlur(fieldName: string) {
    const dateValue = this.data[fieldName].value;
    if (fieldName === 'validity_from' && dateValue) {
      this.data.assignmentValidityAonFrom.value = dateValue;
      this.clearFieldError('assignmentValidityAonFrom');
      $('#assignmentValidityAonFrom').val(dateValue);
    }
    if (fieldName === 'validity_to' && dateValue) {
      this.data.assignmentValidityAonTo.value = dateValue;
      this.clearFieldError('assignmentValidityAonTo');
      $('#assignmentValidityAonTo').val(dateValue);
    }
  }

  loadFilledData() {
    if (this.$store.state.newRequest.conditions) {
      Object.entries(this.$store.state.newRequest.conditions).forEach(
        ([key, value]) => (this.data[key] = { ...this.data[key], value })
      );
    }
    let datepicker = $('#validity_from')
      .datepicker({ dateFormat: 'yyyy/mm/dd' })
      .data('datepicker');
    let date = moment(this.data.validity_from.value);
    if (date.isValid()) {
      datepicker.selectDate(date.toDate());
    }

    datepicker = $('#validity_to')
      .datepicker({ dateFormat: 'yyyy/mm/dd' })
      .data('datepicker');
    date = moment(this.data.validity_to.value);
    if (date.isValid()) {
      datepicker.selectDate(date.toDate());
    }
    datepicker = $('#assignmentValidityAonFrom')
      .datepicker({ dateFormat: 'yyyy/mm/dd' })
      .data('datepicker');
    date = moment(this.data.assignmentValidityAonFrom.value);
    if (date.isValid()) {
      datepicker.selectDate(date.toDate());
    }
    datepicker = $('#assignmentValidityAonTo')
      .datepicker({ dateFormat: 'yyyy/mm/dd' })
      .data('datepicker');
    date = moment(this.data.assignmentValidityAonTo.value);
    if (date.isValid()) {
      datepicker.selectDate(date.toDate());
    }
  }

  async loadCurrencies() {
    let subscriptorId = this.$store.state.user.id;
    const subscriptor: any = await (this.$root as any)._post(
      `subscriptors/one/${subscriptorId}`,
      {
        models: 'companies',
      }
    );
    const company = subscriptor.data[0].companies[0];

    const response: any = await (this.$root as any)._get(
      `companiescurrencies/bycompany/${company.id}`
    );
    response.data.forEach((row) => {
      if (row.can_do_request) {
        this.currencies.push({
          id: row.currency.id,
          title: row.currency.title,
        });
      }
    });
  }

  prevStep() {
    this.$router.push('/requests');
    this.$store.commit(
      'changeStep',
      this.$store.state.newRequest.currentStep - 1
    );
  }

  cancelNewRequest() {
    this.$store.commit('clearNewRequest');
  }

  async nextStep() {
    if (this.validateFields() && await this.validateDates()) {
      let data: any = {};

      Object.entries(this.data).forEach(
        ([key, value]) => (data = { ...data, [key]: (value as any).value })
      );

      this.$store.commit('setNewRequestConditions', data);

      let branch = this.$store.state.newRequest.branch;

      switch (branch) {
        case 1:
          this.$router.push('/requests/new-request/aeronavegacion');
          break;
        case 2:
        case 3:
        case 4:
        case 20:
        case 23:
        case 24:
        case 26:
          this.$router.push('/requests/new-request/automovil-flota');
          break;
        case 21:
          this.$router.push('/requests/new-request/automovil-ovp');
          break;
        default:
          this.$router.push('/requests/new-request/otros');
          break;
      }
    }
  }

  validateFields() {
    const emptyFieldMessage = 'Este campo es obligatorio';
    const invalidDateMessage = 'La fecha o su formato no es válida';
    const invalidAssignmentPercentMessage = 'El porcentaje debe ser mayor a 0,00% y menor a 100%';

    let valid = true;

    const dateFields = [
      'validity_from', 
      'validity_to', 
      'assignmentValidityAonFrom', 
      'assignmentValidityAonTo'
    ];

    const requiredFields: { key: string; message?: string }[] = [
      { key: 'policy_number' },
      { key: 'assignment_percent_aon' },
      { key: 'currency_id', message: 'Debe seleccionar una opción de moneda' },
    ];

    [...dateFields, ...requiredFields.map(rf => rf.key)].forEach(key => {
      this.data[key].error = false;
    });

    dateFields.forEach(key => {
      const field = this.data[key];

      if (!field.value) {
        field.error = true;
        field.errorMessage = emptyFieldMessage;
        valid = false;
      } else if (!moment(field.value, 'YYYY/MM/DD', true).isValid()) {
        field.error = true;
        field.errorMessage = invalidDateMessage;
        valid = false;
      }
    });

    requiredFields.forEach(({ key, message }) => {
      const field = this.data[key];
      if (!field.value) {
        field.error = true;
        field.errorMessage = message || emptyFieldMessage;
        valid = false;
      }
    });

    const assignmentPercent = this.data.assignment_percent_aon.value ? parseFloat(this.data.assignment_percent_aon.value.toString().replace(/\./g, '').replace(',', '.')) : NaN;

    if (!isNaN(assignmentPercent) && (assignmentPercent <= 0 || assignmentPercent > 100)) {
      this.data.assignment_percent_aon.error = true;
      this.data.assignment_percent_aon.errorMessage = invalidAssignmentPercentMessage;
      valid = false;
    }

    return valid;
  }

  async validateDates() {
    const dates: any = {
      assignmentValidityAonFrom: this.data.assignmentValidityAonFrom.value,
      assignmentValidityAonTo: this.data.assignmentValidityAonTo.value,
      validity_from: this.data.validity_from.value,
      validity_to: this.data.validity_to.value,
    };

    try {
      await (this.$root as any)._post('requests/conditions/validate', dates);

      return true;
    } catch (e: any) {
      const validationErrors = e && e.data && Array.isArray(e.data.errors) ? e.data.errors : [];

      if (validationErrors.length > 0) {

        validationErrors.forEach((err: { field: string; message: string }) => {
          const field = err && err.field;
          
          if (field && this.data[field]) {
            this.data[field].error = true;
            this.data[field].errorMessage = err && err.message ? err.message : `El campo "${this.data[field].label}" es inválido`;
          }
        });
      } else (this.$root as any).notify("Ocurrió un error, intentelo nuevamente", 'error');

      return false;
    }
  }
}
